/* eslint-disable */
/* eslint-disable import/prefer-default-export */
export function priceDecimalizer(priceInCents) {
    if (typeof priceInCents !== 'number') return null;
    return ((priceInCents/100).toFixed( 2 ))
}
